<template>
  <div
    id="vessel-container-pictures"
    class="flex"
    :class="{ 'justify-center': containerPictures.length <= 0 }"
  >
    <!-- クリックした写真を表示するとこ -->
    <div
      id="selected-picture-wrapper"
      class="flex-shrink-0"
      v-if="containerPictures.length > 0"
    >
      <selected-picture
        :selectedPicture="selectedPicture"
        :selectedImgSrc="selectedImgSrc"
        :resetSelectedPicture="resetSelectedPicture"
        :popupActive="popupActive"
      />
    </div>
    <!-- 写真リスト -->
    <div id="picture-list" class="pt-6">
      <div class="vx-row" v-if="containerPictures.length > 0">
        <div
          class="container-picture-wrapper vx-col w-full mb-base"
          v-for="(picture, index) in containerPictures"
          :key="picture.sorted_key"
        >
          <card-container-picture
            :pictureData="picture"
            :index="index"
            :selectPicture="selectPicture"
            :popupActive="popupActive"
            :key="picture.sorted_key"
            :selectedIndex="selectedIndex"
            :localPictureLastUpdatedAt="localPictureLastUpdatedAt"
          />
        </div>
      </div>
      <div class="mt-4 mb-4 text-center" v-else v-show="isPictureReady">
        <span class="text-lg leading-none">送信された点検表はありません</span>
      </div>
    </div>
  </div>
</template>

<script>
import CardContainerPicture from "./CardContainerPicture.vue";
import SelectedPicture from "./SelectedPicture.vue";

export default {
  name: "VesselContainerPictures",
  components: {
    CardContainerPicture,
    SelectedPicture,
  },
  mixins: [],
  props: {
    enterpriseVesselId: { type: String },
    containerPictures: { type: Array, default: () => [] },
    isPictureReady: { type: Boolean, default: () => false },
    localPictureLastUpdatedAt: { type: Number, default: () => null },
  },
  data() {
    return {
      selectedIndex: null,
      selectedImgSrc: null,
      popupActive: false,
    };
  },
  watch: {},
  computed: {
    selectedPicture() {
      if (this.containerPictures.length === 0) return null;
      return this.containerPictures[this.selectedIndex];
    },
  },
  methods: {
    selectPicture(index, imgSrc, popupActive = true) {
      this.selectedIndex = index;
      this.selectedImgSrc = imgSrc;
      this.popupActive = popupActive;
    },
    resetSelectedPicture() {
      this.selectedIndex = null;
      this.selectedImgSrc = null;
    },
  },

  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
#vessel-container-pictures {
  @media screen and (min-width: $max-width-ipad-pro-12) {
    grid-gap: 2.5rem;
    gap: 2.5rem;
  }
  #selected-picture-wrapper {
    @media screen and (min-width: $max-width-ipad-pro-12) {
      width: calc(100% - 250px);
    }
  }
  #picture-list {
    width: 100%;
    @media screen and (min-width: $max-width-ipad-pro-12) {
      padding-top: 3.75rem;
    }
    .vx-row {
      justify-content: center;
      @media screen and (min-width: $max-width-iphone-8) {
        justify-content: flex-start;
      }
      .container-picture-wrapper {
        max-width: 240px;
        @media screen and (min-width: $max-width-ipad-pro-12) {
          width: fit-content;
          justify-content: center;
        }
      }
    }
  }
}
</style>